import {makeAutoObservable} from "mobx";
import {makePersistable} from "mobx-persist-store";
import {sessionService} from "@/services";
import {SessionFilesInfo} from "Player";

class Clip {
    sessionId: string;
    range: [number, number];
    interested?: boolean | null = null;
}

class ClipStore {
    list: Clip[] = [];
    sessions: SessionFilesInfo[] = [];
    currentIndex = 1;
    nextId: string | null = null;
    prevId: string | null = null;
    loading = false;
    introduced = false;
    skipped = false;
    tour = true;
    total = 0;
    completed = false;
    autoplay = false;
    ready = false;

    constructor() {
        makeAutoObservable(this);

        void makePersistable(this, {
            name: 'ClipStore',
            properties: ['tour', 'autoplay', 'completed', 'currentIndex', 'introduced', 'skipped'],
            storage: window.localStorage,
        })
        // this.initializeStore();
    }

    get currentItem() {
        return this.list[this.currentIndex];
    }

    isCurrent(sessionId: string) {
        return this.currentClip?.sessionId === sessionId;
    }

    toggleTour() {
        this.tour = !this.tour;
    }

    toggleAutoplay() {
        this.autoplay = !this.autoplay;
    }

    setReady = (val) => {
        this.ready = val;
    }

    initializeStore() {
        this.list = [
            {
                sessionId: "3114838595895215713",
                range: [100, 10000],
                interested: null
            },
            {
                sessionId: "3114710713361417731",
                range: [100, 10000],
                interested: true
            },
            {
                sessionId: "3113417250204468984",
                range: [100, 10000],
                interested: false
            }, {
                sessionId: "3113412728459544272",
                range: [5000, 18000],
                interested: true
            }, {
                sessionId: "3113400333183927850",
                range: [2000, 10000],
                interested: null
            }];
        this.updateNavigationIds();
        this.total = this.list.length;
    }

    resetStore() {
        this.list = [];
        this.currentIndex = 0;
        this.total = 0;
        this.completed = false;
        this.updateNavigationIds();
    }

    get currentClip() {
        return this.list[this.currentIndex] ?? null;
    }

    setIntroduced() {
        this.introduced = true;
    }

    setCurrentIndex(index: number) {
        this.currentIndex = index;
        this.updateNavigationIds();
        this.completed = false;
    }

    updateNavigationIds() {
        this.nextId = this.list[this.currentIndex + 1]?.sessionId ?? null;
        this.prevId = this.list[this.currentIndex - 1]?.sessionId ?? null;
    }

    toggleSkipped = () => {
        this.skipped = true
    }

    next() {
        this.skipped = true;
        if (this.currentIndex < this.total - 1) {
            this.currentIndex++;
            this.updateNavigationIds();
        } else {
            this.completed = true;
        }
    }

    prev() {
        if (this.currentIndex > 0) {
            this.currentIndex--;
            this.updateNavigationIds();
        }
    }

    async sendFeedback(interested?: boolean) {
        if (!this.list[this.currentIndex]) return;

        const {sessionId} = this.list[this.currentIndex];
        this.list[this.currentIndex].interested = interested;
        return sessionService.sendFeedback({sessionId, payload: {interested}});
    }

    async fetchClips() {
        this.loading = true;
        try {
            const data: any = await sessionService.fetchSessionClips();
            if (data?.sessions?.length) {
                const list = data.sessions.flatMap((session: any) => {
                        return session.windows.map((window: any) => ({
                            sessionId: session.sessionId,
                            range: [window[0] - session.startTs, window[1] - session.startTs],
                            interested: null
                        }))
                    }
                );

                this.total = list.length;
                this.list = list;
                this.updateNavigationIds();
            } else {
                this.resetStore();
            }
        } catch (e) {
            console.error('Error fetching clips:', e);
        } finally {
            this.loading = false;
        }
    }

}

export default ClipStore;
